import { spacingMixin, token } from '@zillow/constellation';
/* eslint-disable no-confusing-arrow */

import { css } from 'styled-components';

const hasContent = ({ children, color }) =>
  children
    ? css`
        ::before,
        ::after {
          background: ${token(`colors.${color}`)};
          content: '';
          flex-grow: 1;
          font-size: 0;
          height: 1px;
          line-height: 0;
          margin: 0 8px;
        }
      `
    : css`
        ::before,
        ::after {
          background: ${token(`colors.${color}`)};
          content: '';
          flex-grow: 1;
          font-size: 0;
          height: 1px;
          line-height: 0;
        }
      `;

export default (props) =>
  props.theme &&
  props.theme.ns &&
  css`
    & {
      align-items: center;
      display: flex;
      flex-basis: 100%;
      margin: 20px 0;
      ${hasContent}
      ${spacingMixin};
    }
  `;
